import { useEffect, useState, useRef } from "react";
import { useAppDispatch } from "../../../../store/hooks";
import { getCustomerPortalReportsFileAvailability } from "../../../../store/api/apiSlice";

export function useCustomerPortalReportsFileAvailability(
  orderNumber: string,
  reportType: string
) {
  const dispatch = useAppDispatch();

  const [availability, setAvailability] = useState<Record<string, boolean>>({});
  const [loading, setLoading] = useState(false);

  const hasFetched = useRef(false);
  const lastKey = useRef<string>("");

  useEffect(() => {
    if (!orderNumber || !reportType) return;

    const key = `${orderNumber}-${reportType}`;

    // 🚫 prevent repeated calls for same params
    if (lastKey.current === key) return;
    lastKey.current = key;

    const load = async () => {
      setLoading(true);

      try {
        const result: any = await dispatch(
          getCustomerPortalReportsFileAvailability({
            orderNumber,
            reportType,
          })
        );

        const data = result?.payload || {};

        setAvailability((prev) => {
          // 🚫 prevent useless state updates
          const same =
            JSON.stringify(prev) === JSON.stringify(data);

          return same ? prev : data;
        });
      } catch (e) {
        setAvailability({});
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [dispatch, orderNumber, reportType]);

  return { availability, loading };
}